import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("页面未找到-球幕影院", "你访问的页面不存在，返回球幕影院首页继续探索沉浸式影片。");

  return (
    <div className="w-full pt-20 min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center">
        <p className="font-heading font-bold text-6xl md:text-8xl text-accent-500/30 mb-4">404</p>
        <h1 className="font-heading font-semibold text-xl md:text-2xl text-foreground-950 mb-3">
          页面走丢了
        </h1>
        <p className="text-sm text-foreground-600 mb-8 max-w-sm mx-auto leading-relaxed">
          你要找的页面可能已下线或地址有误，回到首页继续发现精彩的穹顶影片吧。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 font-label font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/films"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300/70 text-foreground-900 font-label hover:bg-background-200/60 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-movie-2-line" />
            浏览影片
          </Link>
        </div>
      </div>
    </div>
  );
}